import {call, select} from 'redux-saga/effects'
import {SUBMIT, submitFailure, submitSuccess, submitWaiting} from "./actions";
import {StripeCheckout} from "../services";
import {sendToServer} from "../utils/sagas";

function* saga(stripe = StripeCheckout.instance()) {
    yield* sendToServer({
        EVENT: SUBMIT,
        request: function* () {
            const details = yield select(state => state.payments.details);
            const token = yield call([stripe, stripe.createChargeToken], {
                name:        'Paraglide Utah, LLC',
                description: details.description,
                email:       details.email,
                amount:      details.amount * 100
            });
            return {
                url:  '/api/payment',
                data: {
                    name:        details.name,
                    email:       details.email,
                    amount:      parseFloat(details.amount),
                    description: details.description,
                    token
                }
            };
        },
        waiting: submitWaiting,
        success: submitSuccess,
        failure: submitFailure
    });
}

export default saga;



// WEBPACK FOOTER //
// ./src/app/payments/sagas.js